import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';

import Content from '../childrens/content/.mixins';
import { ModalBloqueioAntecipacao } from '../../modalBloqueioAntecipacao';

export default function AlertDialog(props) {
  const { handleCloseModel: handleCloseModal } = props;
  const { openModel: isModalOpen, bodyEscolhido } = props.state;
  const [quantidadeEntrega, setQuantidadeEntrega] = useState(0);

  
  useEffect(() => {
    if(bodyEscolhido.qt_entrg) {
      setQuantidadeEntrega(parseInt(bodyEscolhido.qt_entrg));
    }
  }, [bodyEscolhido]);

  
  return (
    <div>
      <Dialog
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {quantidadeEntrega > 0 ? (
          <ModalBloqueioAntecipacao
            isModalOpen={isModalOpen}
            handleCloseModal={handleCloseModal}
          />
        ):(
          <Content {...props}/>
        )}
      </Dialog>
    </div>
  );
}